import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

import { isEmpty } from "lodash";
import { isIos } from "@/utils/lodash";
import * as types from "@/store/constants/types";
import { face_get_settings } from "@/api/faceServe/index";
import { judgeLocalVideoAndConfig } from "@/utils/judgeVersion";
import { sendMapEvent } from "@/utils/analytics";
import { erroToMsg } from "@/utils/errorToMsg";
var actions = (_actions = {}, _defineProperty(_actions, types.REQUEST_SETTING_DATA, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
            _context.prev = 1;
            _context.next = 4;
            return dispatch(types.REQUEST_NATIVE_SETTING);

          case 4:
            face_get_settings().then(function (result) {
              console.log("boss setting===========", result);
              commit(types.REQUEST_SETTING_DATA, result.data);
              dispatch(types.UPDATE_LOCAL_FILES, result.data);
              dispatch(types.REGISTER_PRODUCT_ID).catch(function (error) {}); //更新原生

              Cordova.exec(function (res) {
                console.info("settingsRefreshed:", res);
              }, function (err) {
                console.info("settingsRefreshed error:", err);
              }, "ThirdPartyPlugin", "settingsRefreshed", [result.data]);
            }).catch(function (error) {});
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.REQUEST_NATIVE_SETTING, function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref3) {
    var state, commit, getters, setting_cache, current_app_platform, settingData, path, fileName, _path, _settingData;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref3.state, commit = _ref3.commit, getters = _ref3.getters;

            try {
              console.log("REQUEST_NATIVE_SETTING"); // 如果NativeStorage内存储过

              setting_cache = getters[types.GETTER_SETTING_DATA];
              current_app_platform = window.device && window.device.appPlatform;

              if (isEmpty(setting_cache)) {
                settingData = {};
                path = "/android/";

                if (isIos()) {
                  path = "/ios/";
                }

                if (process.env.NODE_ENV === "production" && process.env.VUE_APP_SETTING_MODE === "production") {
                  //正式服setting
                  fileName = current_app_platform + "_Setting.json";
                  settingData = require("@/assets/json" + path + fileName);
                } else {
                  //本地服务器和测试服setting
                  settingData = require("@/assets/json" + path + "setting.json");
                }

                commit(types.REQUEST_SETTING_DATA, settingData);
              }
            } catch (e) {
              console.log("REQUEST_NATIVE_SETTING error: ", e);
              _path = isIos() ? "/ios/" : "/android/";
              _settingData = require("@/assets/json" + _path + "setting.json");
              commit(types.REQUEST_SETTING_DATA, _settingData);
              sendMapEvent("uia_request_default_setting_failed", {
                value: erroToMsg(e)
              });
            }

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3) {
    return _ref4.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GET_LAUNCH_CONFIG, function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(_ref5) {
    var state, commit, getters, getConfig, resultConfig;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            state = _ref5.state, commit = _ref5.commit, getters = _ref5.getters;
            _context3.prev = 1;

            //version:
            getConfig = function getConfig() {
              return new _Promise(function (resolve, reject) {
                Cordova.exec(function (res) {
                  console.info("GetLaunchConfig:", res);
                  resolve(res);
                }, function (err) {
                  console.info("GetLaunchConfig error:", err);
                  reject(err);
                }, "ThirdPartyPlugin", "GetLaunchConfig", []);
              });
            };

            if (!judgeLocalVideoAndConfig()) {
              _context3.next = 10;
              break;
            }

            _context3.next = 6;
            return getConfig();

          case 6:
            resultConfig = _context3.sent;
            commit(types.UPDATE_LAUNCH_CONFIG, resultConfig);
            _context3.next = 11;
            break;

          case 10:
            console.log("老版本无法获取"); //老版本无法获取,是否需要给予默认的参数:

          case 11:
            _context3.next = 16;
            break;

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](1);
            console.log("GET_NATIVE_SETTING error: ", _context3.t0);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 13]]);
  }));

  return function (_x4) {
    return _ref6.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.UPDATE_LOCAL_FILES, function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(_ref7, payload) {
    var state, commit, getters, dispatch, updateLocalVideo, fileList;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            state = _ref7.state, commit = _ref7.commit, getters = _ref7.getters, dispatch = _ref7.dispatch;

            try {
              //version:
              updateLocalVideo = function updateLocalVideo(fileList) {
                console.log("updateLocalVideo:", fileList);
                return new _Promise(function (resolve, reject) {
                  Cordova.exec(function (res) {
                    console.info("UpdateLocalFiles:", res);
                    resolve(res);
                  }, function (err) {
                    console.info("UpdateLocalFiles error:", err);
                    reject(err);
                  }, "ThirdPartyPlugin", "UpdateLocalFiles", fileList);
                });
              };

              if (judgeLocalVideoAndConfig()) {
                //新版本
                fileList = payload.client.vip_config.vip_video_resources;
                updateLocalVideo(fileList);
              } else {//老版本无法
              }
            } catch (e) {
              console.log("UPDATE_LOCAL_FILES error: ", e);
            }

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}()), _actions);
export default actions;